import { DashboardContent } from 'features/Dashboard/DashboardContent'
import DashboardAbilityProvider from 'features/Dashboard/Providers/DashboardAbilityProvider'
import DashboardFilterContextProvider from 'features/Dashboard/Providers/DashboardFilterContendProvider'
import DashboardPopupProvider from 'features/Dashboard/Providers/DashboardPopupProvider'
import { fetchHealthSystemsList } from 'features/HealthSystems/api'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { getUser } from 'redux/store/user/getters'

export const Dashboard = () => {
  const currenUser = useSelector(getUser)
  const [healthSystem, setHealthSystem] = useState(
    currenUser?.health_system || ''
  )

  useEffect(() => {
    // to remove in future - left only to show 3 dots menu on 'expected savings' chart & modals
    if (currenUser?.community) {
      fetchHealthSystemsList(currenUser?.community as string, {}).then(
        (resp) => {
          const hsList = [{ label: 'All', value: '' }]
          if (resp?.data?.results?.length) {
            hsList.push(
              ...resp.data.results.map((item) => ({
                label: item.name,
                value: item.uuid
              }))
            )
          }
          if (currenUser?.health_system) {
            setHealthSystem(
              hsList.find((i) => i.value === currenUser.health_system)?.value ||
                ''
            )
          }
        }
      )
    }
    // eslint-disable-next-line
  }, [currenUser?.community])

  return (
    <DashboardAbilityProvider>
      <DashboardFilterContextProvider>
        <DashboardPopupProvider>
          <DashboardContent healthSystem={healthSystem as string} />
        </DashboardPopupProvider>
      </DashboardFilterContextProvider>
    </DashboardAbilityProvider>
  )
}
